import _ from 'lodash';
import {DomainObject} from 'shared/store';
import { observable, action, computed, makeObservable } from 'mobx';
import {filestackUploadPolicy} from 'shared/core';
import IndeedIntegrationStatus from './IndeedIntegrationStatus';

class Image extends DomainObject {
  fileName;
  fileSize;
  contentType;
  key;
  label;

  constructor(other) {
    super();

    makeObservable(this, {
      fileName: observable,
      fileSize: observable,
      contentType: observable,
      key: observable,
      label: observable,
      uploadedUrl: computed
    });

    this.merge(other);
  }

  get uploadedUrl() {
    return `${this.label}?policy=${filestackUploadPolicy.policy}&signature=${filestackUploadPolicy.signature}`;
  }
}

class JobSite extends DomainObject {
  website;
  urlSlug;
  socialSharingImage;
  indeedEnabled;
  indeedApplyEnabled;
  indeedDispositionSyncEnabled;
  indeedCompanyName;
  indeedAccountEmail;
  indeedIntegrationStatus;

  _relations = {
    indeedIntegrationStatus: IndeedIntegrationStatus,
    socialSharingImage: Image
  };

  constructor(other) {
    super();

    makeObservable(this, {
      website: observable,
      urlSlug: observable,
      socialSharingImage: observable,
      indeedEnabled: observable,
      indeedApplyEnabled: observable,
      indeedDispositionSyncEnabled: observable,
      indeedCompanyName: observable,
      indeedAccountEmail: observable,
      indeedIntegrationStatus: observable,
      permalink: computed,
      hasPermalink: computed,
      integrationLink: computed,
      hasSocialSharingImage: computed,
      hasUploadedSocialSharingImage: computed,
      socialSharingImageUrl: computed,
      updateSocialSharingImage: action
    });

    this.merge(other);
  }

  get permalink() {
    return this.link('permalink');
  }

  get hasPermalink() {
    return this.hasLink('permalink');
  }

  get integrationLink() {
    return `https://api.collage.co/v1/positions/${this.urlSlug}`;
  }

  get hasSocialSharingImage() {
    return !!this.socialSharingImage && !!this.socialSharingImage.fileName;
  }

  get hasUploadedSocialSharingImage() {
    return this.hasSocialSharingImage && !this.socialSharingImageUrl;
  }

  get socialSharingImageUrl() {
    return _.get(this.socialSharingImage, 'links.url.href');
  }

  updateSocialSharingImage(json) {
    return this.merge({ socialSharingImage: json });
  }
}

export default JobSite;
